import React from "react";
import { Drawer, Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";

const RightDrawer = ({ open, onClose, title, children }) => {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{ sx: { width: { xs: "100%", sm: 400 } } }}
    >
      <Box className="p-4 flex flex-col h-full">
        {/* Title & Close Button */}
        <Box className="flex justify-between items-start mb-2">
          <Typography variant="h6" className="font-bold">
            {title || "Drawer"}
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Drawer Content */}
        <Box className="flex-grow overflow-auto mt-4">{children}</Box>
      </Box>
    </Drawer>
  );
};

RightDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
};

export default RightDrawer;
